import { render, staticRenderFns } from "./fanliSapXiangqing.vue?vue&type=template&id=a39bc45e&scoped=true"
import script from "./fanliSapXiangqing.vue?vue&type=script&lang=js"
export * from "./fanliSapXiangqing.vue?vue&type=script&lang=js"
import style0 from "./fanliSapXiangqing.vue?vue&type=style&index=0&id=a39bc45e&prod&scoped=true&lang=css"
import style1 from "./fanliSapXiangqing.vue?vue&type=style&index=1&id=a39bc45e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39bc45e",
  null
  
)

export default component.exports